import Alert from "@mui/material/Alert";

export default function CartErrorAlert({ severity = "warning", alertContent }) {
  return (
    <Alert severity={severity}>
      {alertContent}
    </Alert>
  );
};
